import { TrackHelper } from "./track_helper";

const ADDITIONAL_COMBOS_AND_SIMILAR_COMBOS_TRACKING_POSITION = 3;
const ADDITIONAL_COMBOS_WITHOUT_SIMILAR_COMBOS_TRACKING_POSITION = 2;
const ONLY_SIMILAR_COMBOS_TRACKING_POSITION = 2;

export default function initMoreCombosTracking(_document) {
	const tilesSections = Array.from(_document.getElementsByTagName("section")).filter(
		section =>
			section.className.includes("combo_presentation-additional_combos") ||
			section.className.includes("combo_presentation-similar_combos")
	);

	const thereAreAnyTypeOfTiles = tilesSections && tilesSections.length > 0;
	const thereAreAdditionalCombosInTheFirstPosition = tilesSections[0].className.includes(
		"combo_presentation-additional_combos"
	);
	const thereAreSimilarCombosInTheFirstPosition = tilesSections[0].className.includes(
		"combo_presentation-similar_combos"
	);
	const thereAreSimilarCombosInTheSecondPosition =
		tilesSections.length > 1 && tilesSections[1].className.includes("combo_presentation-similar_combos");

	if (thereAreAnyTypeOfTiles) {
		if (thereAreAdditionalCombosInTheFirstPosition) {
			trackMoreCombos(tilesSections[0], ADDITIONAL_COMBOS_WITHOUT_SIMILAR_COMBOS_TRACKING_POSITION);
			if (thereAreSimilarCombosInTheSecondPosition) {
				trackMoreCombos(tilesSections[1], ADDITIONAL_COMBOS_AND_SIMILAR_COMBOS_TRACKING_POSITION);
			}
		} else if (thereAreSimilarCombosInTheFirstPosition) {
			trackMoreCombos(tilesSections[0], ONLY_SIMILAR_COMBOS_TRACKING_POSITION);
		}
	}
}

function trackMoreCombos(section, position) {
	const tilesContainers = section.getElementsByClassName("combo_presentation-tiles_tracking");
	if (!tilesContainers || tilesContainers.length === 0) {
		return;
	}

	const tiles = Array.from(tilesContainers[0].querySelectorAll("a"));
	const trackHelper = new TrackHelper();
	const promoType = tilesContainers[0].dataset.promoType;
	const isRoom = tilesContainers[0].dataset.isRoom;
	const isACFA = promoType === "Wozda";
	const comboType = isRoom === "true" ? "ROOM" : "OUTFIT";

	attachClickEventListenersToTiles(tiles, trackHelper, position, isACFA, comboType);
	trackViewEvent(tiles, trackHelper, position, isACFA, comboType);
}

function trackViewEvent(tiles, trackHelper, position, isACFA, comboType) {
	const viewTrackingInfo = {
		tiles: tiles.map(item => {
			return {
				id: item.dataset.comboId,
				similarityScore: item.dataset.similarityScore ?? null,
				comboSource: item.dataset.comboSource
			};
		})
	};
	trackHelper.sendTileViewTrackingEvent(viewTrackingInfo, position, comboType, isACFA);
}

function attachClickEventListenersToTiles(tiles, trackHelper, position, isACFA, comboType) {
	tiles.forEach((item, index) =>
		item.addEventListener("click", () =>
			trackHelper.sendTileClickTrackingEvent(
				getSimilarityTrackingInfo(item, index, tiles.length),
				position,
				comboType,
				isACFA
			)
		)
	);
}

function getSimilarityTrackingInfo(item, index, numberOfCombos) {
	return {
		clickedCombo: {
			id: item.dataset.comboId,
			similarityScore: item.dataset.similarityScore ?? null,
			position: index + 1,
			comboSource: item.dataset.comboSource
		},
		numberOfCombos
	};
}
